import Api from './api';

const OuvidoriaService = {
    cadastro: async (params) => {
        const response = await Api.post('/ouvidoria/cadastrar', params)
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/ouvidoria/listar',
            params: params
        })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/ouvidoria/editar/${id}`,
            params)
        return response
    },
    buscar: async (params) => {
        const response = await Api.get(`/ouvidoria/buscar?${params}`)
        return response
    },
    contarSituacao: async (params) => {
        const response = await Api.get(`/ouvidoria/contarSituacao?${params}`)
        return response
    },
    buscarSigilo: async (params) => {
        const response = await Api.get(`/ouvidoria/buscarSigilo?${params}`)
        return response
    },
    listarSigilo: async (params) => {
        const response = await Api.get(`/ouvidoria/listarSigilo`)
        return response
    },
    buscarDescla: async (params) => {
        const response = await Api.get(`/ouvidoria/buscarDescla?${params}`)
        return response
    },
    listarDescla: async (params) => {
        const response = await Api.get(`/ouvidoria/listarDescla`)
        return response
    },
    listar: async () => {
        const response = await Api.get(`/ouvidoria/listar`)
        return response
    },
    publicas: async (params) => {
        const response = await Api.get(`/ouvidoria/publicas?${params}`)
        return response
    }
}

export default OuvidoriaService;